module.exports = __webpack_public_path__ + "img/Group 715t3.dc4ce40a.svg";